import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'

import { UtilsService } from '../../services/utils.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from '../../../environments/environment';
import { APIConfigService } from '../../config/api-config';
import { FiltersComponent } from '../../../app/components/filters/filters.component';
import { SignUpService } from '../../services/sign-up.service';
import { AddNewAddressComponent } from "../../../app/components/add-new-address/add-new-address.component";
import { OtpComponent } from "../../../app/components/otp/otp.component";
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-shared-model',
  standalone:true,
  imports: [CommonModule
    // , AddNewAddressComponent, OtpComponent, FiltersComponent
  ],
  templateUrl: './shared-model.component.html',
  styleUrls: ['./shared-model.component.scss']
})
export class SharedModelComponent implements OnInit,OnDestroy {
  modelData: any = [];
  sub:Subscription=new Subscription()
  @Input('isOtpSection') isOtpSection!: boolean;
  environment: any = environment;
  loadingCookieContent: any;
filterData: any;


  constructor(public utils: UtilsService, public dialogRef: MatDialogRef<FiltersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private signUpsvc: SignUpService, private apiConfig: APIConfigService) {
    this.modelData = data;
  }

  ngOnInit(): void {
    this.removeDialogPadding()
  }
  onClose(event: any) {
    this.dialogRef.close(event);
  }
  removeDialogPadding(): void {
    const dialogContainer = document.getElementsByClassName('mat-dialog-container')[0] as HTMLElement;
    if (dialogContainer) {
      dialogContainer.style.padding = '0';
    }
  }

  onSubmitOtp(otpCode: any) {
    let body = {
      "otpCode": otpCode,
      "phone": this.data.phone,
      "purpose": "ProfileUpdate"
    }
    this.utils.showLoading();
    if (!otpCode) {
      this.utils.openSnackBar("Please enter otp!", 'error-toster');
      this.utils.hideLoading();
      return
    }
    this.utils.showLoading();
    this.sub.add(  this.signUpsvc.verifyOtp(this.apiConfig.end_points.VERIFY_OTP, body, {})
      .subscribe({
        next: (data: any) => {
          if (data.success) {
            this.utils.openSnackBar(data.message, 'success-toster');
            this.dialogRef.close(true);
          } else {
            this.utils.openSnackBar(data.message, 'error-toster');
            this.utils.hideLoading();
          }
        },
        error: (err: any) => {
          this.utils.hideLoading();
          this.utils.openSnackBar(err.error.error, 'error-toster');
        }
      }))
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
